import { render, staticRenderFns } from "./PosLoginForm.vue?vue&type=template&id=9ffd1a3c&scoped=true"
import script from "./PosLoginForm.vue?vue&type=script&lang=js"
export * from "./PosLoginForm.vue?vue&type=script&lang=js"
import style0 from "./PosLoginForm.vue?vue&type=style&index=0&id=9ffd1a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffd1a3c",
  null
  
)

export default component.exports